import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { AppConfig } from 'src/app/app.config';
import { HttpClient } from '@angular/common/http';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';

@Injectable({
	providedIn: 'root'
})
export class DriversService {

	constructor(private http: HttpClient,
		private config: AppConfig) { }

	datatable(data) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/dt`, data);
	}

	get(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/` + id);
	}

	getAll() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/all`);
	}

	update(a: Autista) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers`, a);
	}

	insert(a: Autista) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers`, a);
	}

	delete(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/` + id);
	}

	getDriverMyself() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/myself`);
	}

	wizardInsert(a: Array<Autista>) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/wizard`, a);
	}

}

export class Autista {

	id: number;
	id_partner: number;
	nome: string;
	cognome: string;
	numero_patente: string;
	tipo_patente: string;
	scadenza_patente: Date;
	data_di_nascita: Date;
	prefisso: string;
	telefono: string;
	tipo: string;
	telefono_obj: {
		"telefono": string;
		"prefisso": string;
	};
	email: string;
	accetta_pos: number;
	id_veicolo_default: number;
	cancellato: number;
	is_partner: number;
}
